import { createEvent } from 'modules-core/utility'
import { AudioEffect, createVolumeEffect } from 'modules-core/audioEffectSystem'
import { iAudioSystem } from 'modules-core/audioSystem'
import { eventSystem } from 'modules-core/eventSystem'

// Register events.
eventSystem.add('setMusicVolume')

interface Args {
	audioSystem: iAudioSystem
}
export const createMusicSystem = ({ audioSystem }: Args) => {
	const { effectSystem } = audioSystem
	let volume = 1
	const onChange = createEvent<number>()
	const system = {
		onChange,
		// get volume() { return volume },
		setVolume: (val: number) => {
			volume = val
			onChange.invoke(volume)
			eventSystem.dispatch('setMusicVolume', val)
		},
		createMusicVolume: (
			wet: AudioEffect.VolumeEffect,
			dry: AudioEffect.VolumeEffect,
			dryAnalyser: AudioEffect.AnalyserEffect,
			effect: AudioEffect.Effect
		) => {
			const wetMusic = createVolumeEffect()
			const dryMusic = createVolumeEffect()
			wetMusic.value = volume
			dryMusic.value = volume
			wet.connect(wetMusic)
			dry.connect(dryMusic)
			wetMusic.connect(effect)
			if (dryAnalyser) {
				dryMusic.connect(dryAnalyser)
				dryAnalyser.connect(effectSystem.globalVolume)
			} else {
				dryMusic.connect(effectSystem.globalVolume)
			}
			const handleChange = (volume: number) => {
				wetMusic.fadeToValue(volume)
				dryMusic.fadeToValue(volume)
			}
			onChange.addListener(handleChange)
			return () => onChange.removeListener(handleChange)
		}
	}
	return system
}

export type MusicSystem = ReturnType<typeof createMusicSystem>
